import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    overflow: "hidden",
    margin: 0,
    padding: 0,
  },
  card: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    width: "100%",
    maxWidth: "60vh",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      maxWidth: "90%",
    },
    position: "relative",
  },
  cardHeader: {
    textAlign: "center",
  },
  titleImage: {
    width: "80px",
    height: "auto",
    objectFit: "contain",
    marginBottom: theme.spacing(2),
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
  buttonProgress: {
    color: theme.palette.common.white,
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default useStyles;
